import React from 'react';

import "./MDLCalc.css";
import Section from "../../Section";
import MDCCalc from "../../MDCCalc";

export default function MDLCalc(props) {
  return <Section>
    <a name="mdl-calc"></a>
    <div className="mdl-grid">
      <div className="pb-4 mdl-cell mdl-cell--6-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone mdl-typography--display-1-color-contrast">
        <h1>MDC-Calc</h1>
        <h3 className="mdl-calc-desc">A state based desktop calculator using the Material Design Component Web Framework + React</h3>
      </div>
      <div className="mdl-cell mdl-cell--6-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone mdl-typography--display-1-color-contrast">
        <div style={{border: "1px solid grey", display: "inline-block"}}><MDCCalc /></div>
      </div>
    </div>
  </Section>
}



// WEBPACK FOOTER //
// ./src/Pages/MDLCalc/MDLCalc.js